<template>
  <div ref="title" style="">
    <!-- <Header /> -->
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router';
import Header from 'components/header.vue';
import Main from 'mitumori/main.vue';
import Top from 'top/index.vue';
import login from 'login/index.vue'

const router = new VueRouter({
  routes: [
    {
      path: '/', component: Main
    },
    {
      path: '/top', component: Top, name: 'top'
    },
    {
      path: '/main', component: Main, name: 'main'
    }, 
       // ログイン
    {
      path: '/login', component: login, name: 'login'
    },
  ]
})

Vue.use(VueRouter)

export default {
  mounted : function(){
    document.title = '販売管理'
  },    
  components: {
    Header
  },
  data: function () {
    return {

    }
  },
  router
}
</script>

<style scoped>
</style>